import React from "react"
import { graphql } from "gatsby"
import Layout from "gatsby-theme-blank/src/components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import AdditionalInformation from "gatsby-theme-blank/src/components/additional-information"
import {
  pageAddress,
  pageAddressAdditionalInfos,
  addressTitle,
  addressContact,
  addressMail,
  addressTel,
  addressContentFooter,
  addressContentFooterBack,
  addressPlace,
  addressCarouselContainer,
  gridAriane,
  gridAddress,
  gridContent,
  gridResume,
  gridTitle,
  editButton,
} from "./styles/detailsAddress.module.scss"
import Carousel from "gatsby-theme-blank/src/components/Carousel/carousel"
import PropTypes from "prop-types"
import {
  AdditionalInfos,
  AdressPlaceIcon,
  AdressPlaceTitle,
  AddressTitle,
  AddressFooterContainer,
} from "./styled-components/adresse-styled"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import Obfuscate from "react-obfuscate"
import ProcessedLink from "gatsby-theme-blank/src/components/processed-link"
import { ContentSplitter } from "gatsby-theme-blank/src/components/ContentSplitter/content-splitter"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeCarnetDAdresse(path: { alias: { eq: $slug } }) {
      ...AdresseItem
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Parent Component---------------------------//

const AdresseTemplate = ({ data, location }) => {
  const nodeAddress = data.nodeCarnetDAdresse
  const allTaxos = nodeAddress.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout isDetail={true}>
      <SEO
        title={nodeAddress.title}
        description={
          "Dans cette page, vous découvrez l'adresse suivante : " +
          nodeAddress.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          nodeAddress.relationships?.field_image_adresse?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <div className={pageAddress}>
        <AddressImg nodeAddress={nodeAddress} />
        <div className={gridAriane}>
          <Ariane
            pageNameLink="/adresses"
            pageName="Carnet d'adresses"
            isDetail={true}
            postName={nodeAddress.title}
          />
        </div>
        <div className={gridTitle}>
          <EditButton
            link={"/node/" + nodeAddress.drupal_internal__nid + "/edit"}
            addedClass={editButton}
          />
          <AddressTitle className={addressTitle}>
            {nodeAddress.title}
          </AddressTitle>
        </div>
        <AddressAdressContact nodeAddress={nodeAddress} />
        <AddressContent nodeAddress={nodeAddress} />
      </div>
      <AddressContentFooter
        nodeAddress={nodeAddress}
        location={location.href}
      />
      <AddressInfos nodeAddress={nodeAddress} />
    </Layout>
  )
}

//-----------------------Parent Component---------------------------//

//-----------------------Child Component/Content---------------------------//

const AddressContent = ({ nodeAddress }) => {
  return (
    <>
      <ContentSplitter
        node={nodeAddress}
        resumeClassName={gridResume}
        contentClassName={gridContent}
        splitPoint={625}
      />
    </>
  )
}

//-----------------------Child Component/Content---------------------------//

//-----------------------Child Component/Address---------------------------//

const AddressAdressContact = ({ nodeAddress }) => (
  <div className={gridAddress}>
    <div>
      <p>{nodeAddress.field_adresse?.address_line1}</p>
      <p>{nodeAddress.field_adresse?.address_line2}</p>
      <p>
        {nodeAddress.field_adresse?.postal_code}{" "}
        {nodeAddress.field_adresse?.locality}
      </p>
    </div>
    <AddressContact nodeAddress={nodeAddress} />
    {nodeAddress.field_url_lieu && (
      <div className={addressPlace}>
        <ProcessedLink link={nodeAddress.field_url_lieu.uri}>
          <AdressPlaceIcon size={30} icon="earth"></AdressPlaceIcon>
          <AdressPlaceTitle>
            {nodeAddress.field_url_lieu.title}
          </AdressPlaceTitle>
        </ProcessedLink>
      </div>
    )}
  </div>
)

//-----------------------Child Component/Address---------------------------//

//-----------------------Child Component/Img---------------------------//

const AddressImg = ({ nodeAddress }) => (
  <div className={addressCarouselContainer}>
    <Carousel address={nodeAddress} />
  </div>
)

//-----------------------Child Component/Img---------------------------//

//-----------------------Child Component/Footer---------------------------//

const AddressContentFooter = () => (
  <AddressFooterContainer className={addressContentFooter}>
    <div className={addressContentFooterBack}>
      <TransitionFade
        arialabel="Retour aux carnets d'adresses"
        link="/adresses"
      >
        Retour aux carnets d&apos;adresses
      </TransitionFade>
    </div>
  </AddressFooterContainer>
)

//-----------------------Child Component/Footer---------------------------//

//-----------------------Child Component/Infos---------------------------//

const AddressInfos = ({ nodeAddress }) => (
  <>
    {nodeAddress.field_infos_complementaires && (
      <AdditionalInfos className={pageAddressAdditionalInfos}>
        <AdditionalInformation node={nodeAddress} />
      </AdditionalInfos>
    )}
  </>
)

//-----------------------Child Component/Infos---------------------------//

//-----------------------Sub-Child Component/Contact---------------------------//

const AddressContact = ({ nodeAddress }) => (
  <>
    <div className={addressContact}>
      {nodeAddress.field_mail && (
        <Obfuscate
          email={nodeAddress.field_mail}
          className={addressMail}
          aria-label={"Contacter par mail"}
        />
      )}
      {nodeAddress.field_telephone && (
        <Obfuscate tel={nodeAddress.field_telephone} className={addressTel} />
      )}
    </div>
  </>
)

//-----------------------Sub-Child Component/Contact---------------------------//

//-----------------------Prop-Types---------------------------//

AdresseTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
AddressContent.propTypes = {
  nodeAddress: PropTypes.object.isRequired,
}
AddressImg.propTypes = {
  nodeAddress: PropTypes.object.isRequired,
}
AddressAdressContact.propTypes = {
  nodeAddress: PropTypes.object.isRequired,
}
AddressContact.propTypes = {
  nodeAddress: PropTypes.object.isRequired,
}
AddressInfos.propTypes = {
  nodeAddress: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default AdresseTemplate
